// FEWD-336: the legacy location-SEO and directory pages are discontinued.
// These suffixes match the new app's /rankings/{viewType} values 1:1
// (utr-web-app src/app/(public)/(directory)/locations/viewTypes.ts) — keep
// the two lists in sync if a view type is ever added.
export const SEO_LOCATION_VIEW_SUFFIXES = [
    'mens-tennis-rankings',
    'womens-tennis-rankings',
    'boys-tennis-rankings',
    'girls-tennis-rankings',
    'mens-pickleball-rankings',
    'womens-pickleball-rankings',
    'boys-pickleball-rankings',
    'girls-pickleball-rankings',
    'tennis-tournaments',
    'pickleball-tournaments',
    'tennis-leagues',
    'pickleball-leagues',
];

export const SEO_LOCATION_ROUTE_REGEX = new RegExp(
    `^/([^/]+(?:/[^/]+){0,2})/(${SEO_LOCATION_VIEW_SUFFIXES.join('|')})/?$`,
);

export const LEGACY_DIRECTORY_PATHS = [
    '/countries',
    '/states',
    '/cities',
    '/cities/:letter',
    '/directory',
];

const STATIC_DIRECTORY_REDIRECTS = {
    '/countries': '/directory/countries',
    '/states': '/directory/states',
    '/cities': '/directory/cities/a',
};

const CITIES_LETTER_REGEX = /^\/cities\/([^/]+)\/?$/;

const NEW_APP_PATH_PREFIXES = ['/rankings', '/locations', '/directory'];

export const seoLocationRedirectPath = (pathname) => {
    // Express's default non-strict routing lets /countries/ reach the
    // /countries handler with the slash preserved on req.path — normalize
    // before branching so the trailing-slash variants don't fall through
    // to the /locations catch-all (which 404s on the new app).
    const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
    const alreadyNewShape = NEW_APP_PATH_PREFIXES.some(
        prefix => normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`),
    );
    if (alreadyNewShape) {
        return normalizedPath;
    }
    if (STATIC_DIRECTORY_REDIRECTS[normalizedPath]) {
        return STATIC_DIRECTORY_REDIRECTS[normalizedPath];
    }
    const citiesLetterMatch = CITIES_LETTER_REGEX.exec(normalizedPath);
    if (citiesLetterMatch) {
        return `/directory/cities/${citiesLetterMatch[1]}`;
    }
    const suffixedMatch = SEO_LOCATION_ROUTE_REGEX.exec(normalizedPath);
    if (suffixedMatch) {
        return `/rankings/${suffixedMatch[2]}/${suffixedMatch[1]}`;
    }
    return `/locations${normalizedPath}`;
};
